<template>
    <!-- 服务指南 -->
    <div>
    <div style="width:100%;height:60px"></div>
  <div class="container-middle">
     <el-row style="width:100%;" type="flex" justify="center">

         <el-row type="flex" justify="left">
                   <el-col :span="35" style="text-align:left；">
                     <label class="label-font"><font style="color:black ;font-size:30px;font-width:normal;height:200px;margin-top:-100px">港中旅华贸物流-24小时为您服务</font></label>
                   </el-col>

      </el-row>
      </el-row>
  </div>
  <div style="width:100%;height:15px"></div>
 <div style=" width:100%;background:gray;overflow:hidden; height:1px;border-width:2px;top:22px"></div>
<div style="width:100%;height:2px"></div>

<div style="width:100%;height:0px;margin-left:25px;display:'inline-block'">
<font style="font-size:20px">
 营销中心:
 </font>
</div>
<div style="width:100%;height:0px;margin-left:180px;display:'inline-block'">
<font style="font-size:20px;color:red">
   021-5248684
 </font>
</div>

<div style="width:100%;height:0px;margin-top:35px;margin-left:25px;display:'inline-block'">
<font style="font-size:20px">
 运力1组:
 </font>
</div>
<div style="width:100%;height:0px;margin-left:180px;display:'inline-block'">
<font style="font-size:20px;color:red">
   021-5247824
 </font>
</div>

<div style="width:100%;height:0px;margin-top:35px;margin-left:25px;display:'inline-block'">
<font style="font-size:20px">
 运力2组:
 </font>
</div>
<div style="width:100%;height:0px;margin-left:180px;display:'inline-block'">
<font style="font-size:20px;color:red">
   0755-5234892
 </font>
</div>

<div style="width:100%;height:0px;margin-top:35px;margin-left:25px;display:'inline-block'">
<font style="font-size:20px">
 运力3组:
 </font>
</div>
<div style="width:100%;height:0px;margin-left:180px;display:'inline-block'">
<font style="font-size:20px;color:red">
   0755-5234892
 </font>
</div>

<div style="width:100%;height:0px;margin-top:35px;margin-left:25px;display:'inline-block'">
<font style="font-size:20px">
 运力4组:
 </font>
</div>
<div style="width:100%;height:0px;margin-left:180px;display:'inline-block'">
<font style="font-size:20px;color:red">
   0592-5823564
 </font>
</div>

<div style="width:100%;height:0px;margin-top:35px;margin-left:25px;display:'inline-block'">
<font style="font-size:20px">
 运力5组:
 </font>
</div>
<div style="width:100%;height:0px;margin-left:180px;display:'inline-block'">
<font style="font-size:20px;color:red">
   0532-5432880
 </font>
</div>

<div style="width:100%;height:0px;margin-top:35px;margin-left:25px;display:'inline-block'">
<font style="font-size:20px">
 运力6组:
 </font>
</div>
<div style="width:100%;height:0px;margin-left:180px;display:'inline-block'">
<font style="font-size:20px;color:red">
   0411-5147835
 </font>
</div>


<div style="width:100%;height:0px;margin-top:35px;margin-left:25px;display:'inline-block'">
<font style="font-size:20px">
 运力7组:
 </font>
</div>
<div style="width:100%;height:0px;margin-left:180px;display:'inline-block'">
<font style="font-size:20px;color:red">
   023-5732168
 </font>
</div>

<div style="width:100%;height:0px;margin-top:35px;margin-left:25px;display:'inline-block'">
<font style="font-size:20px">
 运力8组:
 </font>
</div>
<div style="width:100%;height:0px;margin-left:180px;display:'inline-block'">
<font style="font-size:20px;color:red">
   025-5436548
 </font>
</div>

<div style="width:100%;height:0px;margin-top:35px;margin-left:25px;display:'inline-block'">
<font style="font-size:20px">
 运力9组:
 </font>
</div>
<div style="width:100%;height:0px;margin-left:180px;display:'inline-block'">
<font style="font-size:20px;color:red">
   0574-5187964
 </font>
</div>

<div style="width:100%;height:0px;margin-top:35px;margin-left:25px;display:'inline-block'">
<font style="font-size:20px">
 运力10组:
 </font>
</div>
<div style="width:100%;height:0px;margin-left:180px;display:'inline-block'">
<font style="font-size:20px;color:red">
   010-5110230
 </font>
</div>

      </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    async created() {

    },
    mounted() {

    },
    methods: {

    }
};
</script>

<style scoped lang="less">

</style>
